// extracted by mini-css-extract-plugin
export var editButton = "_n4-0";